var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFrutiger65Bold = function SvgFrutiger65Bold(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("version", null, "1.0"), /*#__PURE__*/React.createElement("id", null), /*#__PURE__*/React.createElement("vendor", null, "Monotype Imaging Inc."), /*#__PURE__*/React.createElement("credits", null, /*#__PURE__*/React.createElement("name", null, "Fonts.com WebFonts"), /*#__PURE__*/React.createElement(URL, null, "http://webfonts.fonts.com"), /*#__PURE__*/React.createElement("role", null, "Home of the Web fonts")), /*#__PURE__*/React.createElement("license", null, /*#__PURE__*/React.createElement(URL, null, "http://webfonts.fonts.com/Legal")), /*#__PURE__*/React.createElement("copyright", null), /*#__PURE__*/React.createElement("trademark", null), /*#__PURE__*/React.createElement("licensee", null, /*#__PURE__*/React.createElement("name", null)))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    horizAdvX: 541,
    id: "FrutigerLTW0165Bold"
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "",
    panose1: "2 11 8 3 3 5 4 2 2 4",
    ascent: 933,
    descent: -250,
    unitsPerEm: 1000,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\n"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\r",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 278
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 389,
    d: "M118 698H272L251 205H137L118 698ZM125 140H265V0H125V140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 481,
    d: "M271 698H393V448H271V698ZM88 698H210V448H88V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 556,
    d: "M494 205H402L373 0H285L314 205H212L182 0H94L123 205H33V285H134L151 413H63V493H163L191 698H280L252 493H354L382 698H470L442 493H523V413H430L413 285H494V205ZM240 413L223 285H325L342 413H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 556,
    d: "M259 590Q236 580 220 559Q204 539 204 503Q204 479 220 463Q234 447 259 434V590ZM306 112Q332 123 348 142Q364 161 364 188Q364 216 348 235Q332 253 306 265V112ZM306 782V710Q394 710 469 685L456 570Q389 599 314 600Q310 600 306 599V414Q340 402 376 387Q411 371 441 348Q472 325 491 289Q510 253 510 199Q509 102 452 52Q395 2 306 -8V-90H259V-11Q253 -12 248 -12Q194 -12 157 -4Q119 3 69 15L82 141Q156 99 240 98Q249 98 259 100V287Q225 300 190 316Q155 332 125 354Q96 376 77 412Q58 446 58 497Q59 600 119 650Q177 700 259 708V782H306Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1000,
    d: "M729 68Q769 69 781 105Q791 138 791 172Q791 207 781 241Q769 275 729 276Q691 275 678 241Q664 207 665 172Q664 138 678 105Q691 69 729 68ZM677 720H759L327 -22H245L677 720ZM274 342Q108 344 106 526Q108 707 274 710Q438 707 440 526Q438 344 274 342ZM274 422Q314 423 326 459Q336 492 336 526Q336 561 326 595Q314 629 274 630Q236 629 223 595Q209 561 210 526Q209 492 223 459Q236 423 274 422ZM729 -12Q563 -9 561 172Q563 353 729 356Q893 353 895 172Q893 -9 729 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 722,
    d: "M279 307Q244 290 220 263Q194 237 194 195Q195 149 230 121Q263 92 312 92Q348 92 380 102Q411 112 434 134L279 307H279ZM310 439Q340 453 369 481Q400 509 401 540Q400 577 378 595Q356 612 324 612Q293 612 269 595Q244 577 244 538Q245 509 268 485Q289 460 310 439ZM516 227Q541 258 551 298Q559 338 560 379H682Q677 243 593 140L718 0H546L499 62Q462 25 412 7Q362 -12 309 -12Q203 -12 133 41Q61 93 60 191Q59 254 92 302Q126 349 207 383Q166 420 139 457Q110 493 110 551Q112 631 180 671Q244 710 322 710Q399 710 460 674Q521 637 523 552Q522 482 485 441Q446 399 388 367L516 227H516Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 278,
    d: "M78 698H200V448H78V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 333,
    d: "M326 756Q261 656 222 551Q181 445 181 308Q185 58 326 -140H199Q41 58 39 308Q39 445 82 551Q123 656 199 756H326Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 333,
    d: "M7 -140Q147 58 152 308Q151 445 112 551Q72 656 7 756H133Q209 656 251 551Q294 445 294 308Q291 58 133 -140H7Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 556,
    d: "M345 475L441 368L349 302L278 426L202 302L111 368L209 475L72 506L105 610L238 553L222 698H336L319 554L452 610L484 506L345 475Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 600,
    d: "M248 506H352V305H554V201H352V0H248V201H46V305H248V506Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 278,
    d: "M87 140H232L141 -110H23L87 140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 333,
    d: "M35 214V324H298V214H35Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 278,
    d: "M69 140H209V0H69V140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 389,
    d: "M265 710H369L125 -12H21L265 710Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 556,
    d: "M277 92Q317 92 339 120Q360 147 369 187Q379 228 381 271Q381 314 381 347Q381 383 380 427Q378 470 368 511Q359 553 338 579Q316 605 277 606Q240 605 219 579Q198 553 188 511Q180 470 177 427Q175 383 175 347Q175 314 177 271Q180 228 188 187Q198 147 219 120Q240 92 277 92ZM277 -12Q198 -11 150 25Q101 59 76 114Q51 169 43 231Q35 292 35 347Q35 414 47 479Q59 543 86 595Q114 647 161 679Q207 710 277 710Q353 709 402 677Q450 643 476 590Q502 537 512 473Q521 409 521 347Q521 286 512 224Q502 162 475 108Q449 55 401 22Q353 -11 277 -12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 556,
    d: "M283 698H407V0H267V539L149 443L79 534L283 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 556,
    d: "M41 0V117Q68 142 117 188Q166 232 217 288Q270 345 306 401Q342 457 343 506Q342 554 308 578Q275 600 229 600Q185 600 144 584Q103 567 68 544L57 660Q155 709 264 710Q478 710 483 506Q482 451 459 398Q435 345 395 295Q311 194 220 110H505V0H41Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 556,
    d: "M53 130Q125 99 208 98Q231 98 257 104Q281 110 304 121Q327 133 341 153Q355 171 355 197Q354 258 312 283Q270 306 201 306H133V416H197Q269 416 310 440Q351 463 352 508Q352 535 343 553Q333 571 316 581Q282 600 232 600Q149 600 75 563L67 675Q153 709 262 710Q296 710 335 704Q375 697 410 677Q446 658 469 623Q491 588 492 531Q491 461 455 423Q418 384 362 364V362Q429 352 462 307Q495 262 495 196Q494 135 471 94Q446 54 406 30Q386 20 365 12Q343 4 320 -2Q273 -12 228 -12Q130 -12 45 11L53 130H53Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 556,
    d: "M317 249V552H315L142 249H317ZM16 258L277 698H451V249H540V145H451V0H317V145H16V258Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 556,
    d: "M490 594H221L218 445Q242 451 282 452Q320 452 360 443Q398 433 432 407Q466 382 487 338Q507 294 507 225Q507 125 439 58Q370 -10 235 -12Q148 -11 72 8L75 133Q101 122 137 111Q173 98 218 98Q276 98 320 127Q366 155 367 221Q366 288 317 316Q270 342 207 342Q175 342 145 338Q114 334 82 323L89 698H490V594Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 556,
    d: "M460 572Q433 584 403 592Q374 600 338 600Q250 598 212 531Q174 466 172 384L174 382Q222 452 309 452Q511 447 513 239Q513 125 457 57Q399 -11 281 -12Q139 -9 90 90Q65 136 55 194Q44 251 44 313Q42 462 104 583Q165 706 331 710Q407 710 478 685L460 572H460ZM278 348Q228 347 206 309Q184 270 184 216Q184 165 207 130Q231 93 281 92Q330 93 352 132Q373 169 373 217Q373 270 351 309Q329 347 278 348Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 556,
    d: "M50 698H500V582L252 0H100L359 588H50V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 556,
    d: "M163 364Q110 388 79 430Q47 471 47 526Q48 620 111 666Q173 710 269 710Q365 710 433 671Q501 630 503 542Q503 494 475 447Q445 401 387 375V374Q522 310 521 191Q520 86 453 37Q387 -12 281 -12Q177 -12 108 36Q36 83 35 189Q35 303 163 362V364ZM181 522Q181 500 192 484Q203 467 219 455Q236 443 255 434Q273 424 291 417Q322 429 346 457Q368 485 369 518Q369 558 347 582Q324 605 283 606Q244 606 214 585Q182 564 181 522ZM175 191Q176 147 208 121Q238 92 281 92Q324 92 352 117Q380 141 381 185Q380 237 345 265Q310 293 264 306Q226 289 201 262Q175 236 175 191Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 556,
    d: "M97 126Q151 99 219 98Q309 100 347 167Q383 232 385 314L383 316Q335 245 248 246Q45 251 44 459Q44 575 101 642Q158 709 276 710Q349 709 396 683Q443 656 468 610Q515 513 513 385Q514 237 455 116Q392 -8 226 -12Q150 -12 79 13L97 126H97ZM279 350Q330 351 352 390Q373 428 373 482Q373 533 351 569Q328 605 276 606Q228 605 206 568Q184 530 184 481Q184 429 207 391Q230 351 279 350Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 278,
    d: "M69 515H209V375H69V515ZM69 140H209V0H69V140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 278,
    d: "M87 140H232L141 -110H23L87 140ZM69 515H209V375H69V515Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 600,
    d: "M46 210V296L554 514V412L181 253L554 94V-8L46 210Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 600,
    d: "M554 310H46V414H554V310ZM554 92H46V196H554V92Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 600,
    d: "M419 253L46 412V514L554 296V210L46 -8V94L419 253Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 500,
    d: "M50 677Q147 709 248 710Q338 710 406 669Q474 626 476 531Q475 480 449 440Q422 400 387 365Q353 330 329 292Q303 253 306 204H183Q184 275 207 319Q228 363 256 392Q286 423 308 450Q329 477 330 515Q329 564 295 586Q260 606 215 606Q134 604 61 566L50 677ZM175 140H315V0H175V140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 800,
    d: "M415 446Q365 445 335 405Q303 365 303 318Q303 283 323 260Q343 236 378 236Q427 237 458 278Q489 318 489 366Q489 403 470 424Q450 446 415 446ZM716 143Q599 -14 400 -12Q264 -12 154 79Q40 169 37 349Q38 503 147 605Q253 708 424 710Q552 710 655 641Q760 570 763 416Q762 340 734 288Q705 234 662 201Q621 169 579 154Q538 138 511 138Q489 138 475 152Q459 164 457 190H455Q437 168 411 154Q386 138 354 138Q290 138 246 185Q200 230 199 303Q200 405 260 474Q318 542 405 544Q478 544 521 480L533 528H617L562 285Q555 267 555 251Q554 236 570 236Q610 236 646 279Q682 321 683 413Q683 475 660 515Q637 555 598 577Q580 589 559 598Q538 606 515 610Q470 618 424 618Q297 616 220 538Q142 459 141 349Q142 231 215 157Q286 81 400 80Q461 79 522 92Q583 105 631 143H716Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 722,
    d: "M358 558H356L255 270H459L358 558ZM281 698H439L713 0H558L498 160H215L154 0H9L281 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 611,
    d: "M221 110H287Q313 110 338 114Q363 119 384 129Q430 149 431 207Q431 241 419 263Q407 284 386 294Q365 306 340 310Q314 312 287 312H221V110ZM221 416H278Q326 415 367 432Q387 441 399 458Q410 474 410 501Q410 532 399 550Q387 568 367 576Q347 585 324 587Q300 588 275 588H221V416ZM81 698H325Q360 698 400 693Q438 686 472 667Q507 648 529 613Q549 577 550 519Q549 457 512 416Q475 375 411 363V361Q484 354 527 311Q570 268 571 202Q571 137 546 97Q521 57 482 36Q444 15 402 8Q359 0 325 0H81V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 611,
    d: "M589 10Q511 -11 430 -12Q258 -12 155 75Q48 160 47 337Q54 706 430 710Q505 710 588 681L578 563Q539 585 502 594Q465 600 427 600Q318 599 257 528Q193 457 193 347Q193 238 256 170Q318 99 430 98Q473 98 516 107Q558 115 583 127L589 10Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 722,
    d: "M81 698H272Q438 700 554 628Q611 589 643 522Q675 454 675 349Q675 246 643 179Q611 111 554 71Q498 32 426 16Q354 0 272 0H81V698ZM221 110H299Q391 110 459 173Q527 235 529 349Q527 464 459 526Q391 588 299 588H221V110Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 556,
    d: "M81 698H493V588H221V416H470V306H221V110H495V0H81V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 500,
    d: "M81 698H469V588H221V416H457V306H221V0H81V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 722,
    d: "M626 563Q538 600 446 600Q324 599 259 528Q193 457 193 347Q193 238 256 170Q318 99 430 98Q487 98 522 108V290H374V400H656V24Q544 -10 430 -12Q258 -12 155 75Q48 160 47 337Q54 706 430 710Q548 709 635 681L626 563H626Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 722,
    d: "M81 698H221V416H501V698H641V0H501V306H221V0H81V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 278,
    d: "M69 698H209V0H69V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 389,
    d: "M22 122Q49 110 89 110Q124 110 143 123Q162 136 169 154Q181 193 180 233V698H320V166Q320 139 311 108Q301 78 279 50Q257 23 220 6Q183 -11 129 -12Q76 -12 22 1V122Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 667,
    d: "M81 698H221V398L473 698H645L358 369L657 0H474L223 324H221V0H81V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 500,
    d: "M81 698H221V110H492V0H81V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 944,
    d: "M81 698H305L471 169H473L639 698H863V0H729V576H727L539 0H405L217 576L215 574V0H81V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 722,
    d: "M74 698H246L512 176H514V698H648V0H477L210 522H208V0H74V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 778,
    d: "M47 351Q47 514 135 611Q222 709 389 710Q555 708 643 610Q731 513 731 351Q730 190 644 91Q556 -10 389 -12Q221 -10 135 90Q47 188 47 351ZM193 351Q192 253 238 178Q284 100 389 98Q443 98 481 120Q519 142 541 178Q585 253 585 351Q585 448 540 522Q493 598 389 600Q286 598 240 522Q193 448 193 351Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 556,
    d: "M209 375H258Q313 374 352 397Q390 420 391 479Q391 510 381 531Q370 552 352 564Q314 588 258 588H209V375ZM69 698H246Q364 699 449 656Q535 611 537 487Q536 367 460 316Q384 264 268 265H209V0H69V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 778,
    d: "M544 -132L422 -10Q407 -12 389 -12Q221 -10 135 90Q47 188 47 351Q47 514 135 611Q222 709 389 710Q555 708 643 610Q731 513 731 351Q730 117 555 25L713 -132H544ZM193 351Q192 253 238 178Q284 100 389 98Q443 98 481 120Q519 142 541 178Q585 253 585 351Q585 448 540 522Q493 598 389 600Q286 598 240 522Q193 448 193 351Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 611,
    d: "M209 400H255Q282 400 309 404Q335 407 356 417Q377 427 391 446Q403 466 403 497Q403 529 391 548Q377 566 356 575Q335 584 309 587Q282 588 255 588H209V400ZM69 698H220Q278 698 336 697Q394 694 442 677Q491 661 520 621Q548 582 549 509Q549 447 511 402Q473 357 405 347V345Q433 342 451 320Q469 298 479 273L591 0H435L351 218Q338 257 318 274Q297 290 254 290H209V0H69V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 556,
    d: "M456 570Q389 599 314 600Q296 600 278 596Q259 592 242 581Q226 571 215 551Q204 532 204 503Q204 481 218 466Q232 451 253 439Q276 427 303 417Q329 406 358 394Q387 383 414 368Q442 352 463 329Q484 307 498 276Q510 244 510 199Q508 86 433 37Q358 -12 248 -12Q194 -12 157 -4Q119 3 69 15L82 141Q156 99 240 98Q283 98 323 120Q363 142 364 188Q364 213 352 231Q338 249 317 261Q271 285 212 307Q183 319 157 335Q130 350 107 371Q86 393 72 424Q58 455 58 497Q60 613 135 663Q207 710 302 710Q392 710 469 685L456 570H456Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 556,
    d: "M208 588H8V698H548V588H348V0H208V588Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 722,
    d: "M76 698H216V295Q215 205 249 153Q283 98 361 98Q441 98 474 153Q506 205 506 295V698H646V252Q642 -16 361 -12Q80 -16 76 252V698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 667,
    d: "M10 698H160L339 150H341L518 698H657L422 0H250L10 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1000,
    d: "M10 698H157L287 140H289L408 698H598L721 140H723L854 698H990L808 0H628L502 558H500L376 0H195L10 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 667,
    d: "M239 363L31 698H193L339 449L488 698H638L428 363L657 0H492L331 272L168 0H10L239 363Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 667,
    d: "M266 276L11 698H175L340 405L508 698H656L406 276V0H266V276Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 556,
    d: "M36 114L364 588H49V698H513V584L182 110H520V0H36V114Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 333,
    d: "M72 756H296V658H200V-42H296V-140H72V756Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 389,
    d: "M20 710H124L368 -12H264L20 710Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 333,
    d: "M261 756V-140H37V-42H133V658H37V756H261Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 600,
    d: "M66 313L253 698H347L534 313H430L300 593L170 313H66Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 500,
    d: "M500 -75V-125H0V-75H500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 278,
    d: "M249 585H166L29 731H166L249 585Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 556,
    d: "M92 488Q178 526 271 527Q496 530 493 310V244Q493 169 495 115Q497 58 501 0H383Q377 47 377 77H375Q351 35 308 12Q264 -12 216 -12Q146 -11 93 28Q37 67 36 141Q36 199 62 235Q86 271 124 288Q164 307 209 313Q255 318 297 318H371Q371 380 343 405Q315 429 255 429Q167 428 96 373L92 488ZM164 149Q164 117 189 102Q212 86 249 86Q311 87 343 132Q372 177 371 238H313Q302 238 290 238Q278 238 266 236Q240 233 217 224Q194 215 180 197Q164 179 164 149Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 611,
    d: "M204 259Q203 201 231 149Q245 125 267 109Q289 92 322 92Q355 92 378 109Q400 125 412 149Q425 175 431 204Q435 233 435 259Q435 315 413 368Q401 393 379 408Q357 423 324 423Q260 421 232 368Q204 317 204 259ZM69 750H203V449H205Q257 526 359 527Q476 525 527 447Q576 369 575 259Q576 150 527 71Q476 -10 359 -12Q316 -12 274 5Q232 23 201 63H199V0H69V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 444,
    d: "M403 404Q386 413 365 418Q343 423 312 423Q250 422 214 379Q176 335 176 260Q176 188 211 141Q245 93 315 92Q344 92 373 101Q401 108 418 116L424 5Q396 -4 364 -7Q332 -12 290 -12Q164 -11 101 66Q36 141 36 260Q36 375 101 450Q165 526 285 527Q363 527 415 510L403 404Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 611,
    d: "M176 259Q175 203 200 149Q213 125 235 109Q256 92 289 92Q324 92 346 109Q369 125 382 149Q396 174 402 203Q407 232 407 259Q407 317 380 368Q365 393 343 408Q320 423 287 423Q224 421 199 368Q187 344 182 315Q176 286 176 259ZM412 58H410Q348 -13 252 -12Q135 -10 85 71Q35 150 36 259Q35 369 85 447Q135 525 252 527Q349 527 406 455H408V750H542V0H412V58Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 556,
    d: "M392 308Q390 359 365 393Q339 428 283 429Q228 428 198 395Q168 361 164 308H392ZM482 29Q411 -12 305 -12Q39 -8 36 255Q36 370 96 448Q156 525 275 527Q416 526 470 440Q521 354 520 216H164Q169 154 209 121Q249 86 311 86Q360 86 403 102Q445 116 482 138V29Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 389,
    d: "M118 417H19V515H118V587Q118 666 161 714Q202 761 282 762Q337 761 380 751L369 640Q360 647 347 653Q334 658 311 658Q278 657 265 634Q252 610 252 579V515H369V417H252V0H118V417Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 611,
    d: "M290 104Q353 105 381 152Q408 197 408 263Q408 331 382 376Q354 422 296 423Q229 421 203 372Q175 323 176 260Q176 204 205 156Q220 133 241 119Q262 104 290 104ZM542 515V50Q542 25 540 -1Q537 -27 531 -51Q518 -100 487 -138Q458 -176 404 -198Q351 -221 270 -222Q189 -223 92 -187L103 -73Q136 -90 178 -103Q220 -117 253 -118Q308 -117 341 -99Q372 -80 387 -51Q402 -21 406 14Q408 49 408 82H406Q387 48 346 25Q304 0 246 0Q133 2 85 79Q35 153 36 260Q35 358 88 441Q140 524 254 527Q356 528 412 445H414V515H542Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 611,
    d: "M69 750H203V445H205Q259 525 367 527Q458 526 501 470Q542 414 542 325V0H408V275Q408 300 407 326Q406 352 397 373Q390 396 372 410Q353 423 321 423Q285 423 263 406Q241 389 227 363Q214 337 209 308Q203 278 203 252V0H69V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 278,
    d: "M72 515H206V0H72V515ZM72 737H206V609H72V737Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 278,
    d: "M-10 -118Q43 -116 59 -97Q73 -78 72 -20V515H206V-38Q206 -65 201 -96Q195 -128 179 -157Q163 -184 133 -203Q102 -221 51 -222Q14 -222 -15 -214L-10 -118ZM72 737H206V609H72V737Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 556,
    d: "M72 750H206V309H208L368 515H526L334 285L550 0H380L208 250H206V0H72V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 278,
    d: "M72 750H206V0H72V750Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 889,
    d: "M67 515H192V443H194Q227 490 268 509Q309 527 347 527Q455 528 499 436Q524 483 569 505Q612 527 660 527Q754 526 790 470Q824 414 823 325V0H689V307Q690 346 680 383Q673 401 658 412Q642 423 612 423Q579 423 560 406Q539 389 529 362Q519 336 516 307Q512 276 512 250V0H378V307Q379 346 369 383Q362 401 347 412Q331 423 301 423Q268 423 249 406Q228 389 218 362Q208 336 205 307Q201 276 201 250V0H67V515Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 611,
    d: "M69 515H196V445H198Q262 528 367 527Q458 526 501 470Q542 414 542 325V0H408V275Q408 300 407 326Q406 352 397 373Q390 396 372 410Q353 423 321 423Q285 423 263 406Q241 389 227 363Q214 337 209 308Q203 278 203 252V0H69V515Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 611,
    d: "M36 254Q37 383 114 455Q189 526 305 527Q423 526 498 455Q574 383 575 254Q575 141 505 66Q435 -10 305 -12Q177 -10 107 66Q36 141 36 254ZM176 270Q176 255 178 240Q180 223 183 208Q189 176 203 150Q218 124 243 109Q267 92 305 92Q344 92 370 108Q395 123 410 149Q425 175 430 207Q435 238 435 270Q435 332 404 377Q371 422 305 423Q241 422 209 376Q176 331 176 270Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 611,
    d: "M69 515H197V442H199Q242 524 359 527Q476 525 527 447Q576 369 575 259Q576 150 527 71Q476 -10 356 -12Q314 -12 278 3Q241 18 205 59H203V-210H69V515ZM324 423Q260 421 232 368Q204 317 204 259Q203 201 231 149Q245 125 267 109Q289 92 322 92Q355 92 378 109Q400 125 412 149Q425 175 431 204Q435 233 435 259Q435 315 413 368Q401 393 379 408Q357 423 324 423Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 611,
    d: "M408 59H406Q372 18 335 3Q298 -12 255 -12Q136 -10 86 71Q35 150 36 259Q35 369 86 447Q136 525 255 527Q367 525 412 442H414V515H542V-210H408V59ZM287 423Q224 421 199 368Q187 344 182 315Q176 286 176 259Q175 203 200 149Q213 125 235 109Q256 92 289 92Q324 92 346 109Q369 125 382 149Q396 174 402 203Q407 232 407 259Q407 317 380 368Q365 393 343 408Q320 423 287 423Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 389,
    d: "M72 515H191V398H193Q199 438 237 481Q274 525 334 527Q354 527 375 523V388Q354 399 315 399Q275 399 253 377Q231 356 220 322Q210 290 208 254Q206 219 206 189V0H72V515Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 444,
    d: "M375 407Q346 418 319 424Q292 429 255 429Q227 429 203 418Q177 405 176 372Q177 343 213 331Q230 324 251 318Q272 312 293 304Q316 297 337 286Q357 274 373 258Q390 241 400 217Q409 192 409 156Q407 67 343 27Q279 -12 193 -12Q116 -11 41 10L49 120Q112 86 181 86Q209 86 238 100Q268 113 269 149Q269 169 260 182Q250 194 233 201Q198 215 153 227Q132 234 111 244Q90 254 73 270Q56 286 47 310Q36 333 36 367Q37 451 99 489Q157 527 238 527Q285 527 320 522Q354 516 384 508L375 407Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 389,
    d: "M113 417H14V515H113V618L247 661V515H366V417H247V177Q246 143 260 119Q273 93 310 92Q348 92 371 106L375 0Q335 -12 276 -12Q114 -8 113 155V417Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 611,
    d: "M542 0H415V70H413Q350 -10 244 -12Q153 -11 112 46Q69 102 69 190V515H203V240Q203 229 205 217Q205 205 206 192Q208 166 215 143Q224 121 241 107Q259 92 290 92Q327 92 351 111Q374 128 386 154Q400 180 404 209Q408 238 408 263V515H542V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 556,
    d: "M12 515H156L284 140H286L410 515H544L354 0H203L12 515Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 889,
    d: "M11 515H153L267 134H269L373 515H529L641 134H643L750 515H878L720 0H562L450 393H448L338 0H185L11 515Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 556,
    d: "M27 515H185L286 347L385 515H527L373 270L547 0H387L272 192L156 0H9L186 270L27 515Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 556,
    d: "M283 139H285L409 515H545L352 4Q337 -38 321 -78Q305 -119 282 -151Q260 -183 226 -202Q190 -222 138 -222Q90 -222 43 -208L52 -109Q75 -118 121 -118Q162 -117 185 -92Q208 -67 208 -26L11 515H159L283 139Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 500,
    d: "M47 515H455V405L199 104H464V0H36V109L297 411H47V515Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 333,
    d: "M18 351Q48 350 74 372Q86 383 94 401Q100 419 100 444V621Q101 691 147 724Q192 756 248 756H323V676H278Q246 676 237 657Q227 638 228 603V430Q228 396 217 373Q206 349 189 336Q152 311 116 309V307Q133 306 153 301Q172 295 189 282Q206 269 217 245Q228 220 228 179V13Q227 -22 237 -40Q246 -60 278 -60H323V-140H248Q189 -140 146 -106Q101 -73 100 -5V165Q99 222 74 245Q48 265 18 265V351Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 222,
    d: "M163 750V-250H59V750H163Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 333,
    d: "M315 265Q287 265 261 245Q249 233 241 214Q233 195 233 165V-5Q232 -74 188 -107Q144 -140 85 -140H10V-60H55Q87 -60 97 -40Q105 -22 105 13V179Q105 220 118 245Q129 269 146 282Q182 307 217 307V309Q202 311 183 317Q163 323 146 336Q129 349 118 373Q105 396 105 430V603Q105 638 97 657Q87 676 55 676H10V756H85Q144 756 188 724Q232 691 233 621V444Q234 392 261 372Q287 350 315 351V265Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 600,
    d: "M69 252Q85 285 115 312Q144 339 190 340Q228 340 256 330Q284 320 307 306Q334 293 360 282Q385 270 412 270Q439 271 459 294Q479 315 495 342L531 254Q513 221 484 195Q455 167 416 166Q382 166 354 178Q326 187 300 201Q275 215 250 226Q224 236 191 236Q157 235 137 214Q117 192 105 164L69 252Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 278
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 389,
    d: "M138 310H249L271 -183H117L138 310ZM123 515H263V375H123V515Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 556,
    d: "M343 423Q289 416 258 373Q226 329 226 260Q226 191 258 145L343 423ZM459 608L431 517Q449 515 465 510L453 404Q431 415 401 420L304 105Q330 92 365 92Q394 92 423 101Q451 108 468 116L474 5Q446 -4 414 -7Q382 -12 340 -12Q303 -12 270 -4L243 -90H185L217 14Q86 85 86 260Q86 375 151 450Q215 526 335 527Q357 527 375 525L401 608H459Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    horizAdvX: 556,
    d: "M54 104H142V323H66V403H142V487Q143 589 213 649Q280 709 382 710Q461 710 512 693L505 583Q485 590 461 595Q438 600 408 600Q343 599 313 561Q282 523 282 470V403H429V323H282V104H505V0H54V104Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    horizAdvX: 556,
    d: "M538 552L480 494Q526 429 526 352Q526 276 480 208L538 150L479 91L421 149Q355 103 278 103Q201 103 135 149L77 91L18 150L76 208Q30 276 30 351Q30 428 76 494L18 552L77 611L135 553Q201 599 278 599Q355 599 421 553L479 611L538 552ZM140 351Q141 291 181 250Q220 208 278 207Q337 208 376 250Q415 291 416 351Q415 413 376 453Q337 494 278 495Q220 494 181 453Q141 413 140 351Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    horizAdvX: 556,
    d: "M394 369H492V289H352L345 276V227H492V147H345V0H211V147H64V227H211V276L203 289H64V369H164L-10 698H131L282 390L436 698H567L394 369Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 222,
    d: "M163 675V325H59V675H163ZM163 175V-175H59V175H163Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 556,
    d: "M170 309Q170 285 192 269Q213 251 242 238Q273 225 303 215Q332 203 351 191Q386 219 387 266Q387 293 371 309Q354 325 327 337Q301 349 270 359Q238 370 206 383Q192 374 182 354Q170 334 170 309ZM440 581Q372 606 297 606Q258 606 231 593Q202 578 201 538Q201 519 213 506Q225 491 246 481Q289 461 345 443Q403 425 446 390Q490 355 491 287Q490 203 417 159Q484 118 485 45Q483 -44 416 -89Q349 -136 264 -136Q170 -134 79 -107L88 7Q168 -30 256 -32Q299 -32 328 -17Q356 -1 357 37Q357 56 345 71Q333 86 312 96Q270 116 212 135Q185 146 160 159Q134 171 113 188Q67 222 66 285Q67 378 143 420Q110 443 92 471Q73 499 73 539Q75 627 144 669Q209 710 291 710Q372 709 451 690L440 581H440Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 278,
    d: "M300 737V609H184V737H300ZM-22 609V737H94V609H-22Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 800,
    d: "M657 349Q656 476 583 553Q510 629 400 630Q290 629 218 553Q144 476 143 349Q144 223 218 147Q290 69 400 68Q510 69 583 147Q656 223 657 349ZM589 291Q577 217 529 179Q480 139 414 139Q320 140 266 201Q210 260 210 352Q210 446 264 505Q317 564 412 565Q481 565 528 527Q574 489 586 415H506Q499 451 474 469Q448 485 412 485Q362 484 336 449Q308 412 308 353Q308 296 338 259Q366 219 414 219Q452 219 478 238Q503 256 506 291H589ZM39 349Q41 503 146 605Q248 708 400 710Q554 708 656 605Q759 503 761 349Q759 197 656 95Q554 -10 400 -12Q248 -10 146 95Q41 197 39 349Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    horizAdvX: 361,
    d: "M249 392L246 434H244Q232 406 207 395Q181 384 150 384Q107 384 69 404Q51 414 40 432Q28 448 28 472Q28 510 46 532Q62 554 88 566Q114 578 145 582Q176 584 205 584H242Q242 624 223 638Q204 650 169 650Q112 649 64 619V685Q118 710 184 710Q329 713 328 574Q328 476 333 392H249ZM114 477Q114 458 133 451Q150 444 166 444Q204 444 224 470Q243 495 243 530H213Q199 530 182 530Q165 529 150 524Q135 520 125 509Q114 498 114 477Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 556,
    d: "M390 474H516L406 269L516 64H390L272 269L390 474ZM167 474H293L183 269L293 64H167L49 269L167 474Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    horizAdvX: 600,
    d: "M450 310H46V414H554V108H450V310Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 333,
    d: "M35 214V324H298V214H35Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 800,
    d: "M39 349Q41 503 146 605Q248 708 400 710Q554 708 656 605Q759 503 761 349Q759 197 656 95Q554 -10 400 -12Q248 -10 146 95Q41 197 39 349ZM143 349Q144 223 218 147Q290 69 400 68Q510 69 583 147Q656 223 657 349Q656 476 583 553Q510 629 400 630Q290 629 218 553Q144 476 143 349ZM255 551H406Q483 551 525 525Q566 498 566 431Q565 378 537 353Q508 328 460 324L566 150H478L382 320H341V150H255V551ZM411 386Q443 385 461 396Q480 406 480 439Q479 470 454 478Q430 485 402 485H341V386H411Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 278,
    d: "M-5 618V698H283V618H-5Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 400,
    d: "M200 637Q160 636 137 613Q112 589 112 549Q112 509 137 486Q160 461 200 461Q240 461 264 486Q287 509 288 549Q287 589 264 613Q240 636 200 637ZM200 710Q269 709 314 663Q360 618 361 549Q360 480 315 435Q270 389 200 388Q130 388 85 434Q39 479 39 549Q40 618 87 663Q132 709 200 710Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    horizAdvX: 600,
    d: "M248 506H352V374H554V270H352V137H248V270H46V374H248V506ZM46 104H554V0H46V104Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    horizAdvX: 361,
    d: "M30 282V364Q46 371 77 394Q107 418 138 450Q170 484 192 518Q214 550 214 572Q214 623 153 624Q95 624 48 590L41 677Q104 710 176 710Q242 710 286 681Q329 651 330 581Q330 551 313 519Q296 487 269 456Q210 393 161 370V368H332V282H30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    horizAdvX: 361,
    d: "M41 686Q109 710 170 710Q222 710 274 689Q299 677 314 658Q329 637 329 607Q329 525 246 502V500Q290 496 313 470Q335 442 335 404Q335 369 319 345Q302 320 275 305Q217 276 152 276Q94 276 26 293L31 376Q89 356 139 356Q169 356 194 370Q218 382 219 407Q218 435 198 447Q176 456 146 456Q111 456 90 453V537Q112 536 148 536Q171 536 195 548Q218 559 219 584Q218 611 201 621Q183 630 155 630Q130 630 101 625Q72 619 46 604L41 686Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 278,
    d: "M112 731H249L112 585H29L112 731Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    horizAdvX: 611,
    d: "M69 515H203V240Q203 229 205 217Q205 205 206 192Q208 166 215 143Q224 121 241 107Q259 92 290 92Q327 92 351 111Q374 128 386 154Q400 180 404 209Q408 238 408 263V515H542V0H415V70H413Q402 42 372 16Q342 -11 302 -12Q278 -12 253 -6Q228 -1 205 22H203V-210H69V515Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 620,
    d: "M221 341Q4 345 2 516Q3 620 71 660Q136 699 242 698H535V-124H431V618H325V-124H221V341Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 278,
    d: "M139 207Q104 207 84 229Q62 251 62 284Q62 319 84 340Q104 360 139 361Q174 360 196 340Q216 319 216 284Q216 251 196 229Q174 207 139 207Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 278,
    d: "M95 -147Q110 -151 128 -156Q144 -161 165 -162Q185 -162 201 -154Q217 -146 218 -127Q218 -108 205 -99Q193 -90 174 -91Q150 -91 132 -100L117 -74L176 0H239L193 -53L195 -55Q213 -49 236 -49Q267 -49 291 -65Q315 -82 316 -118Q315 -174 276 -198Q238 -222 191 -222Q150 -221 122 -215Q94 -210 75 -201L95 -147Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    horizAdvX: 361,
    d: "M151 704H245V282H141V602L64 543L12 604L151 704Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    horizAdvX: 397,
    d: "M200 710Q274 710 324 667Q375 624 376 548Q375 471 325 428Q275 384 199 384Q124 384 74 428Q22 471 21 548Q22 624 75 667Q127 710 200 710ZM202 650Q157 649 138 620Q119 590 119 548Q118 505 136 475Q153 444 200 444Q247 445 264 477Q278 507 278 548Q278 588 262 618Q245 649 202 650Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 556,
    d: "M166 64H40L150 269L40 474H166L284 269L166 64ZM389 64H263L373 269L263 474H389L507 269L389 64Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    horizAdvX: 834,
    d: "M581 720H663L246 -22H164L581 720ZM159 704H253V282H149V602L72 543L20 604L159 704ZM656 159V330H654L540 159H656ZM455 164L635 422H760V159H808V79H760V0H656V79H455V164Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    horizAdvX: 834,
    d: "M551 720H633L216 -22H134L551 720ZM149 704H243V282H139V602L62 542L10 603L149 704ZM499 82Q515 89 546 112Q576 136 607 168Q639 202 661 236Q683 268 683 290Q683 341 622 342Q564 342 517 308L510 395Q573 428 645 428Q711 428 755 399Q798 369 799 299Q799 269 782 237Q765 205 738 174Q679 111 630 88V86H801V0H499V82Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    horizAdvX: 834,
    d: "M593 720H675L258 -22H176L593 720ZM29 686Q97 710 158 710Q210 710 262 689Q287 677 302 658Q317 637 317 607Q317 525 234 502V500Q278 496 301 470Q323 442 323 404Q323 369 307 345Q290 320 263 305Q205 276 140 276Q82 276 14 293L19 376Q75 356 133 356Q163 356 188 370Q212 382 213 407Q212 435 188 447Q164 456 134 456Q99 456 78 453V537Q100 536 136 536Q164 536 188 548Q212 559 213 584Q212 611 192 621Q171 630 143 630Q118 630 89 625Q60 619 34 604L29 686ZM668 330H666L554 159H668V330ZM772 0H668V79H467V164L647 422H772V159H820V79H772V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 500,
    d: "M450 -162Q405 -181 353 -188Q302 -195 252 -195Q162 -195 95 -153Q25 -111 24 -16Q25 36 53 76Q80 116 114 151Q149 187 173 225Q197 264 194 311H317Q316 242 295 198Q273 154 244 124Q216 95 194 67Q171 40 170 0Q170 -25 181 -42Q192 -60 208 -71Q244 -91 285 -91Q367 -90 439 -51L450 -162ZM324 375H184V515H324V375Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 722,
    d: "M358 558H356L255 270H459L358 558ZM281 698H439L713 0H558L498 160H215L154 0H9L281 698ZM451 740H368L231 886H368L451 740Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 722,
    d: "M358 558H356L255 270H459L358 558ZM281 698H439L713 0H558L498 160H215L154 0H9L281 698ZM368 886H505L368 740H285L368 886Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 722,
    d: "M358 558H356L255 270H459L358 558ZM281 698H439L713 0H558L498 160H215L154 0H9L281 698ZM417 886L522 740H433L365 826L295 740H206L316 886H417Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 722,
    d: "M358 558H356L255 270H459L358 558ZM281 698H439L713 0H558L498 160H215L154 0H9L281 698ZM188 758Q189 805 218 842Q246 878 290 879Q313 879 332 873Q352 867 371 859Q390 851 408 845Q425 837 444 837Q488 839 488 886H542Q542 835 518 801Q492 766 445 765Q418 765 399 771Q378 776 359 783Q321 801 291 802Q266 801 254 788Q242 774 242 758H188Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 722,
    d: "M358 558H356L255 270H459L358 558ZM281 698H439L713 0H558L498 160H215L154 0H9L281 698ZM528 880V764H412V880H528ZM206 764V880H322V764H206Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 722,
    d: "M358 558H356L255 270H459L358 558ZM281 698H439L713 0H558L498 160H215L154 0H9L281 698ZM367 879Q345 879 331 864T317 828Q317 806 331 792T367 778Q389 778 403 792T418 828Q418 850 404 864T367 879ZM472 828Q472 807 464 788T441 755T407 732T367 724Q346 724 327 732T294 755T272 788T263 828Q263 849 271 868T293 901T327 924T367 933Q388 933 407 925T441 902T463 869T472 828Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 945,
    d: "M480 594H478L305 270H503L480 594ZM391 698H465H609H890V588H619L633 416H868V306H645L661 110H894V0H671H525L513 160H245L159 0H9L391 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 611,
    d: "M589 10Q511 -11 430 -12Q422 -12 416 -11L380 -53L382 -55Q400 -49 423 -49Q454 -49 478 -65Q502 -82 503 -118Q502 -174 463 -198Q425 -222 378 -222Q337 -221 309 -215Q281 -210 262 -201L282 -147Q297 -151 315 -156Q331 -161 352 -162Q372 -162 388 -154Q404 -146 405 -127Q405 -108 392 -99Q380 -90 361 -91Q337 -91 319 -100L304 -74L358 -6Q54 23 47 337Q54 706 430 710Q505 710 588 681L578 563Q539 585 502 594Q465 600 427 600Q318 599 257 528Q193 457 193 347Q193 238 256 170Q318 99 430 98Q473 98 516 107Q558 115 583 127L589 10Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 556,
    d: "M81 698H493V588H221V416H470V306H221V110H495V0H81V698ZM364 740H281L144 886H281L364 740Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 556,
    d: "M81 698H493V588H221V416H470V306H221V110H495V0H81V698ZM280 886H417L280 740H197L280 886Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 556,
    d: "M81 698H493V588H221V416H470V306H221V110H495V0H81V698ZM333 886L438 740H349L281 826L211 740H122L232 886H333Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 556,
    d: "M81 698H493V588H221V416H470V306H221V110H495V0H81V698ZM441 880V764H325V880H441ZM119 764V880H235V764H119Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 278,
    d: "M69 698H209V0H69V698ZM224 740H141L4 886H141L224 740Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 278,
    d: "M69 698H209V0H69V698ZM139 886H276L139 740H56L139 886Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 278,
    d: "M69 698H209V0H69V698ZM191 886L296 740H207L139 826L69 740H-20L90 886H191Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 278,
    d: "M69 698H209V0H69V698ZM299 880V764H183V880H299ZM-23 764V880H93V764H-23Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 722,
    d: "M81 336H17V422H81V698H272Q438 700 554 628Q611 589 643 522Q675 454 675 349Q675 246 643 179Q611 111 554 71Q498 32 426 16Q354 0 272 0H81V336ZM221 110H299Q391 110 459 173Q527 235 529 349Q527 464 459 526Q391 588 299 588H221V422H367V336H221V110Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 722,
    d: "M74 698H246L512 176H514V698H648V0H477L210 522H208V0H74V698ZM188 758Q189 805 218 842Q246 878 290 879Q313 879 332 873Q352 867 371 859Q390 851 408 845Q425 837 444 837Q488 839 488 886H542Q542 835 518 801Q492 766 445 765Q418 765 399 771Q378 776 359 783Q321 801 291 802Q266 801 254 788Q242 774 242 758H188Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 778,
    d: "M47 351Q47 514 135 611Q222 709 389 710Q555 708 643 610Q731 513 731 351Q730 190 644 91Q556 -10 389 -12Q221 -10 135 90Q47 188 47 351ZM193 351Q192 253 238 178Q284 100 389 98Q443 98 481 120Q519 142 541 178Q585 253 585 351Q585 448 540 522Q493 598 389 600Q286 598 240 522Q193 448 193 351ZM479 740H396L259 886H396L479 740Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 778,
    d: "M47 351Q47 514 135 611Q222 709 389 710Q555 708 643 610Q731 513 731 351Q730 190 644 91Q556 -10 389 -12Q221 -10 135 90Q47 188 47 351ZM193 351Q192 253 238 178Q284 100 389 98Q443 98 481 120Q519 142 541 178Q585 253 585 351Q585 448 540 522Q493 598 389 600Q286 598 240 522Q193 448 193 351ZM396 886H533L396 740H313L396 886Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 778,
    d: "M47 351Q47 514 135 611Q222 709 389 710Q555 708 643 610Q731 513 731 351Q730 190 644 91Q556 -10 389 -12Q221 -10 135 90Q47 188 47 351ZM193 351Q192 253 238 178Q284 100 389 98Q443 98 481 120Q519 142 541 178Q585 253 585 351Q585 448 540 522Q493 598 389 600Q286 598 240 522Q193 448 193 351ZM445 886L550 740H461L393 826L323 740H234L344 886H445Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 778,
    d: "M47 351Q47 514 135 611Q222 709 389 710Q555 708 643 610Q731 513 731 351Q730 190 644 91Q556 -10 389 -12Q221 -10 135 90Q47 188 47 351ZM193 351Q192 253 238 178Q284 100 389 98Q443 98 481 120Q519 142 541 178Q585 253 585 351Q585 448 540 522Q493 598 389 600Q286 598 240 522Q193 448 193 351ZM216 758Q217 805 246 842Q274 878 318 879Q341 879 360 873Q380 867 399 859Q418 851 436 845Q453 837 472 837Q516 839 516 886H570Q570 835 546 801Q520 766 473 765Q446 765 427 771Q406 776 387 783Q349 801 319 802Q294 801 282 788Q270 774 270 758H216Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 778,
    d: "M47 351Q47 514 135 611Q222 709 389 710Q555 708 643 610Q731 513 731 351Q730 190 644 91Q556 -10 389 -12Q221 -10 135 90Q47 188 47 351ZM193 351Q192 253 238 178Q284 100 389 98Q443 98 481 120Q519 142 541 178Q585 253 585 351Q585 448 540 522Q493 598 389 600Q286 598 240 522Q193 448 193 351ZM556 880V764H440V880H556ZM234 764V880H350V764H234Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    horizAdvX: 600,
    d: "M66 415L138 487L300 325L462 487L534 415L371 253L534 91L462 19L300 182L138 19L66 91L228 253L66 415Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 778,
    d: "M509 556Q464 599 389 600Q286 598 240 522Q193 448 193 351Q193 264 228 194L509 556ZM264 146Q309 99 389 98Q443 98 481 120Q519 142 541 178Q585 253 585 351Q585 440 546 509L264 146ZM686 690L632 620Q730 521 731 351Q730 190 644 91Q556 -10 389 -12Q265 -11 185 45L128 -29L83 7L142 83Q47 180 47 351Q47 514 135 611Q222 709 389 710Q508 709 587 657L641 727L686 690Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 722,
    d: "M76 698H216V295Q215 205 249 153Q283 98 361 98Q441 98 474 153Q506 205 506 295V698H646V252Q642 -16 361 -12Q80 -16 76 252V698ZM450 740H367L230 886H367L450 740Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 722,
    d: "M76 698H216V295Q215 205 249 153Q283 98 361 98Q441 98 474 153Q506 205 506 295V698H646V252Q642 -16 361 -12Q80 -16 76 252V698ZM368 886H505L368 740H285L368 886Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 722,
    d: "M76 698H216V295Q215 205 249 153Q283 98 361 98Q441 98 474 153Q506 205 506 295V698H646V252Q642 -16 361 -12Q80 -16 76 252V698ZM418 886L523 740H434L366 826L296 740H207L317 886H418Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 722,
    d: "M76 698H216V295Q215 205 249 153Q283 98 361 98Q441 98 474 153Q506 205 506 295V698H646V252Q642 -16 361 -12Q80 -16 76 252V698ZM526 880V764H410V880H526ZM204 764V880H320V764H204Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 667,
    d: "M266 276L11 698H175L340 405L508 698H656L406 276V0H266V276ZM341 886H478L341 740H258L341 886Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 556,
    d: "M69 0V698H209V582H246Q364 583 449 539Q535 494 537 370Q536 250 460 199Q384 148 268 149H209V0H69ZM209 259H258Q313 258 352 281Q390 304 391 363Q391 394 381 415Q370 436 352 448Q314 472 258 472H209V259Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 611,
    d: "M72 0V505Q72 621 134 691Q195 761 318 762Q406 762 474 716Q543 670 545 578Q545 439 412 401V399Q489 389 535 338Q580 287 581 215Q580 112 516 54Q451 -5 347 -6Q293 -4 260 5L264 109Q289 98 334 98Q350 98 368 104Q385 109 402 122Q419 135 430 162Q441 187 441 229Q440 296 395 320Q349 343 284 342V446Q402 445 405 555Q405 598 384 628Q362 657 316 658Q258 657 232 613Q206 570 206 516V0H72Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 556,
    d: "M92 488Q178 526 271 527Q496 530 493 310V244Q493 169 495 115Q497 58 501 0H383Q377 47 377 77H375Q351 35 308 12Q264 -12 216 -12Q146 -11 93 28Q37 67 36 141Q36 199 62 235Q86 271 124 288Q164 307 209 313Q255 318 297 318H371Q371 380 343 405Q315 429 255 429Q167 428 96 373L92 488ZM164 149Q164 117 189 102Q212 86 249 86Q311 87 343 132Q372 177 371 238H313Q302 238 290 238Q278 238 266 236Q240 233 217 224Q194 215 180 197Q164 179 164 149ZM346 585H263L126 731H263L346 585Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 556,
    d: "M92 488Q178 526 271 527Q496 530 493 310V244Q493 169 495 115Q497 58 501 0H383Q377 47 377 77H375Q351 35 308 12Q264 -12 216 -12Q146 -11 93 28Q37 67 36 141Q36 199 62 235Q86 271 124 288Q164 307 209 313Q255 318 297 318H371Q371 380 343 405Q315 429 255 429Q167 428 96 373L92 488ZM164 149Q164 117 189 102Q212 86 249 86Q311 87 343 132Q372 177 371 238H313Q302 238 290 238Q278 238 266 236Q240 233 217 224Q194 215 180 197Q164 179 164 149ZM293 731H430L293 585H210L293 731Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 556,
    d: "M92 488Q178 526 271 527Q496 530 493 310V244Q493 169 495 115Q497 58 501 0H383Q377 47 377 77H375Q351 35 308 12Q264 -12 216 -12Q146 -11 93 28Q37 67 36 141Q36 199 62 235Q86 271 124 288Q164 307 209 313Q255 318 297 318H371Q371 380 343 405Q315 429 255 429Q167 428 96 373L92 488ZM164 149Q164 117 189 102Q212 86 249 86Q311 87 343 132Q372 177 371 238H313Q302 238 290 238Q278 238 266 236Q240 233 217 224Q194 215 180 197Q164 179 164 149ZM334 731L439 585H350L282 671L212 585H123L233 731H334Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 556,
    d: "M92 488Q178 526 271 527Q496 530 493 310V244Q493 169 495 115Q497 58 501 0H383Q377 47 377 77H375Q351 35 308 12Q264 -12 216 -12Q146 -11 93 28Q37 67 36 141Q36 199 62 235Q86 271 124 288Q164 307 209 313Q255 318 297 318H371Q371 380 343 405Q315 429 255 429Q167 428 96 373L92 488ZM164 149Q164 117 189 102Q212 86 249 86Q311 87 343 132Q372 177 371 238H313Q302 238 290 238Q278 238 266 236Q240 233 217 224Q194 215 180 197Q164 179 164 149ZM103 603Q104 650 133 687Q161 723 205 724Q228 724 247 718Q267 712 286 704Q305 696 323 690Q340 682 359 682Q403 684 403 731H457Q457 680 433 646Q407 611 360 610Q333 610 314 616Q293 621 274 628Q236 646 206 647Q181 646 169 633Q157 619 157 603H103Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 556,
    d: "M92 488Q178 526 271 527Q496 530 493 310V244Q493 169 495 115Q497 58 501 0H383Q377 47 377 77H375Q351 35 308 12Q264 -12 216 -12Q146 -11 93 28Q37 67 36 141Q36 199 62 235Q86 271 124 288Q164 307 209 313Q255 318 297 318H371Q371 380 343 405Q315 429 255 429Q167 428 96 373L92 488ZM164 149Q164 117 189 102Q212 86 249 86Q311 87 343 132Q372 177 371 238H313Q302 238 290 238Q278 238 266 236Q240 233 217 224Q194 215 180 197Q164 179 164 149ZM442 737V609H326V737H442ZM120 609V737H236V609H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 556,
    d: "M92 488Q178 526 271 527Q496 530 493 310V244Q493 169 495 115Q497 58 501 0H383Q377 47 377 77H375Q351 35 308 12Q264 -12 216 -12Q146 -11 93 28Q37 67 36 141Q36 199 62 235Q86 271 124 288Q164 307 209 313Q255 318 297 318H371Q371 380 343 405Q315 429 255 429Q167 428 96 373L92 488ZM164 149Q164 117 189 102Q212 86 249 86Q311 87 343 132Q372 177 371 238H313Q302 238 290 238Q278 238 266 236Q240 233 217 224Q194 215 180 197Q164 179 164 149ZM177 685Q178 730 210 761Q240 791 284 792Q330 791 360 761Q389 730 390 685Q389 641 360 611Q330 579 284 579Q240 579 210 611Q178 641 177 685ZM231 685Q231 663 247 649Q261 633 284 633Q307 633 322 649Q336 663 336 685Q336 708 322 724Q307 738 284 738Q261 738 247 724Q231 708 231 685Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 889,
    d: "M725 308Q725 357 701 393Q676 428 620 429Q561 428 531 394Q499 360 499 308H725ZM818 29Q747 -12 641 -12Q578 -12 521 9Q463 29 425 81Q411 57 390 41Q368 23 342 11Q290 -13 233 -12Q157 -12 98 23Q37 58 36 141Q36 195 60 230Q83 265 121 284Q159 304 205 311Q250 318 294 318H371Q371 374 346 402Q319 430 252 430Q164 428 93 373L89 488Q174 526 272 527Q327 527 369 516Q390 510 410 497Q429 483 447 462Q503 526 623 527Q758 524 808 432Q854 341 853 216H499Q500 153 543 120Q584 86 647 86Q696 86 739 102Q781 116 818 138V29ZM164 141Q164 118 184 103Q204 86 240 86Q374 86 371 238H313Q302 238 290 238Q278 237 265 235Q239 231 216 220Q193 210 179 191Q164 171 164 141Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 444,
    d: "M403 404Q386 413 365 418Q343 423 312 423Q250 422 214 379Q176 335 176 260Q176 188 211 141Q245 93 315 92Q344 92 373 101Q401 108 418 116L424 5Q377 -10 313 -11L276 -53L278 -55Q296 -49 319 -49Q350 -49 374 -65Q398 -82 399 -118Q398 -174 359 -198Q321 -222 274 -222Q233 -221 205 -215Q177 -210 158 -201L178 -147Q193 -151 211 -156Q227 -161 248 -162Q268 -162 284 -154Q300 -146 301 -127Q301 -108 288 -99Q276 -90 257 -91Q233 -91 215 -100L200 -74L252 -9Q144 5 90 78Q36 150 36 260Q36 375 101 450Q165 526 285 527Q363 527 415 510L403 404Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 556,
    d: "M392 308Q390 359 365 393Q339 428 283 429Q228 428 198 395Q168 361 164 308H392ZM482 29Q411 -12 305 -12Q39 -8 36 255Q36 370 96 448Q156 525 275 527Q416 526 470 440Q521 354 520 216H164Q169 154 209 121Q249 86 311 86Q360 86 403 102Q445 116 482 138V29ZM346 585H263L126 731H263L346 585Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 556,
    d: "M392 308Q390 359 365 393Q339 428 283 429Q228 428 198 395Q168 361 164 308H392ZM482 29Q411 -12 305 -12Q39 -8 36 255Q36 370 96 448Q156 525 275 527Q416 526 470 440Q521 354 520 216H164Q169 154 209 121Q249 86 311 86Q360 86 403 102Q445 116 482 138V29ZM293 731H430L293 585H210L293 731Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 556,
    d: "M392 308Q390 359 365 393Q339 428 283 429Q228 428 198 395Q168 361 164 308H392ZM482 29Q411 -12 305 -12Q39 -8 36 255Q36 370 96 448Q156 525 275 527Q416 526 470 440Q521 354 520 216H164Q169 154 209 121Q249 86 311 86Q360 86 403 102Q445 116 482 138V29ZM334 731L439 585H350L282 671L212 585H123L233 731H334Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 556,
    d: "M392 308Q390 359 365 393Q339 428 283 429Q228 428 198 395Q168 361 164 308H392ZM482 29Q411 -12 305 -12Q39 -8 36 255Q36 370 96 448Q156 525 275 527Q416 526 470 440Q521 354 520 216H164Q169 154 209 121Q249 86 311 86Q360 86 403 102Q445 116 482 138V29ZM442 737V609H326V737H442ZM120 609V737H236V609H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 278,
    d: "M72 0V515H206V0H72ZM205 585H122L-15 731H122L205 585Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 278,
    d: "M72 0V515H206V0H72ZM148 731H285L148 585H65L148 731Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 278,
    d: "M72 0V515H206V0H72ZM192 731L297 585H208L140 671L70 585H-19L91 731H192Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 278,
    d: "M72 0V515H206V0H72ZM300 737V609H184V737H300ZM-22 609V737H94V609H-22Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 611,
    d: "M307 411Q241 409 209 359Q176 310 176 251Q176 224 184 196Q191 168 206 145Q221 122 246 108Q270 92 306 92Q375 93 404 142Q432 188 432 251Q432 307 403 358Q389 382 365 397Q341 411 307 411ZM228 648Q174 681 129 696L190 764Q257 740 317 705L409 764L460 717L377 664Q567 528 572 282Q569 -9 305 -12Q177 -10 107 66Q36 141 36 254Q35 361 96 437Q157 513 269 515Q312 515 341 507Q370 498 392 483H394Q358 555 288 607L196 547L145 594L228 648Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 611,
    d: "M69 515H196V445H198Q262 528 367 527Q458 526 501 470Q542 414 542 325V0H408V275Q408 300 407 326Q406 352 397 373Q390 396 372 410Q353 423 321 423Q285 423 263 406Q241 389 227 363Q214 337 209 308Q203 278 203 252V0H69V515ZM131 603Q132 650 161 687Q189 723 233 724Q256 724 275 718Q295 712 314 704Q333 696 351 690Q368 682 387 682Q431 684 431 731H485Q485 680 461 646Q435 611 388 610Q361 610 342 616Q321 621 302 628Q264 646 234 647Q209 646 197 633Q185 619 185 603H131Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 611,
    d: "M36 254Q37 383 114 455Q189 526 305 527Q423 526 498 455Q574 383 575 254Q575 141 505 66Q435 -10 305 -12Q177 -10 107 66Q36 141 36 254ZM176 270Q176 255 178 240Q180 223 183 208Q189 176 203 150Q218 124 243 109Q267 92 305 92Q344 92 370 108Q395 123 410 149Q425 175 430 207Q435 238 435 270Q435 332 404 377Q371 422 305 423Q241 422 209 376Q176 331 176 270ZM375 585H292L155 731H292L375 585Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 611,
    d: "M36 254Q37 383 114 455Q189 526 305 527Q423 526 498 455Q574 383 575 254Q575 141 505 66Q435 -10 305 -12Q177 -10 107 66Q36 141 36 254ZM176 270Q176 255 178 240Q180 223 183 208Q189 176 203 150Q218 124 243 109Q267 92 305 92Q344 92 370 108Q395 123 410 149Q425 175 430 207Q435 238 435 270Q435 332 404 377Q371 422 305 423Q241 422 209 376Q176 331 176 270ZM321 731H458L321 585H238L321 731Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 611,
    d: "M36 254Q37 383 114 455Q189 526 305 527Q423 526 498 455Q574 383 575 254Q575 141 505 66Q435 -10 305 -12Q177 -10 107 66Q36 141 36 254ZM176 270Q176 255 178 240Q180 223 183 208Q189 176 203 150Q218 124 243 109Q267 92 305 92Q344 92 370 108Q395 123 410 149Q425 175 430 207Q435 238 435 270Q435 332 404 377Q371 422 305 423Q241 422 209 376Q176 331 176 270ZM362 731L467 585H378L310 671L240 585H151L261 731H362Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 611,
    d: "M36 254Q37 383 114 455Q189 526 305 527Q423 526 498 455Q574 383 575 254Q575 141 505 66Q435 -10 305 -12Q177 -10 107 66Q36 141 36 254ZM176 270Q176 255 178 240Q180 223 183 208Q189 176 203 150Q218 124 243 109Q267 92 305 92Q344 92 370 108Q395 123 410 149Q425 175 430 207Q435 238 435 270Q435 332 404 377Q371 422 305 423Q241 422 209 376Q176 331 176 270ZM131 603Q132 650 161 687Q189 723 233 724Q256 724 275 718Q295 712 314 704Q333 696 351 690Q368 682 387 682Q431 684 431 731H485Q485 680 461 646Q435 611 388 610Q361 610 342 616Q321 621 302 628Q264 646 234 647Q209 646 197 633Q185 619 185 603H131Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 611,
    d: "M36 254Q37 383 114 455Q189 526 305 527Q423 526 498 455Q574 383 575 254Q575 141 505 66Q435 -10 305 -12Q177 -10 107 66Q36 141 36 254ZM176 270Q176 255 178 240Q180 223 183 208Q189 176 203 150Q218 124 243 109Q267 92 305 92Q344 92 370 108Q395 123 410 149Q425 175 430 207Q435 238 435 270Q435 332 404 377Q371 422 305 423Q241 422 209 376Q176 331 176 270ZM470 737V609H354V737H470ZM148 609V737H264V609H148Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    horizAdvX: 600,
    d: "M46 201V305H554V201H46ZM300 529Q335 528 357 508Q377 487 377 452Q377 419 357 397Q335 375 300 375Q265 375 245 397Q223 419 223 452Q223 487 245 508Q265 528 300 529ZM300 -23Q265 -22 245 -1Q223 21 223 54Q223 89 245 110Q265 130 300 131Q335 130 357 110Q377 89 377 54Q377 21 357 -1Q335 -22 300 -23Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 611,
    d: "M384 396Q355 422 305 423Q241 422 209 376Q176 331 176 270Q175 215 194 168L384 396ZM224 122Q253 92 305 92Q344 92 370 108Q395 123 410 149Q425 175 430 207Q435 238 435 270Q435 316 417 354L224 122ZM553 517L499 452Q574 381 575 254Q575 141 505 66Q435 -10 305 -12Q212 -11 148 31L93 -35L52 -2L108 65Q36 139 36 254Q37 383 114 455Q189 526 305 527Q394 526 459 485L513 550L553 517Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 611,
    d: "M542 0H415V70H413Q350 -10 244 -12Q153 -11 112 46Q69 102 69 190V515H203V240Q203 229 205 217Q205 205 206 192Q208 166 215 143Q224 121 241 107Q259 92 290 92Q327 92 351 111Q374 128 386 154Q400 180 404 209Q408 238 408 263V515H542V0ZM374 585H291L154 731H291L374 585Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 611,
    d: "M542 0H415V70H413Q350 -10 244 -12Q153 -11 112 46Q69 102 69 190V515H203V240Q203 229 205 217Q205 205 206 192Q208 166 215 143Q224 121 241 107Q259 92 290 92Q327 92 351 111Q374 128 386 154Q400 180 404 209Q408 238 408 263V515H542V0ZM320 731H457L320 585H237L320 731Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 611,
    d: "M542 0H415V70H413Q350 -10 244 -12Q153 -11 112 46Q69 102 69 190V515H203V240Q203 229 205 217Q205 205 206 192Q208 166 215 143Q224 121 241 107Q259 92 290 92Q327 92 351 111Q374 128 386 154Q400 180 404 209Q408 238 408 263V515H542V0ZM361 731L466 585H377L309 671L239 585H150L260 731H361Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 611,
    d: "M542 0H415V70H413Q350 -10 244 -12Q153 -11 112 46Q69 102 69 190V515H203V240Q203 229 205 217Q205 205 206 192Q208 166 215 143Q224 121 241 107Q259 92 290 92Q327 92 351 111Q374 128 386 154Q400 180 404 209Q408 238 408 263V515H542V0ZM469 737V609H353V737H469ZM147 609V737H263V609H147Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 556,
    d: "M283 139H285L409 515H545L352 4Q337 -38 321 -78Q305 -119 282 -151Q260 -183 226 -202Q190 -222 138 -222Q90 -222 43 -208L52 -109Q75 -118 121 -118Q162 -117 185 -92Q208 -67 208 -26L11 515H159L283 139ZM293 731H430L293 585H210L293 731Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 611,
    d: "M69 750H203V448H205Q224 481 263 504Q301 526 359 527Q476 525 527 447Q576 369 575 259Q576 150 527 71Q476 -10 359 -12Q303 -11 266 9Q229 28 205 58H203V-210H69V750ZM324 423Q260 421 232 368Q204 317 204 259Q203 201 231 149Q245 125 267 109Q289 92 322 92Q355 92 378 109Q400 125 412 149Q425 175 431 204Q435 233 435 259Q435 315 413 368Q401 393 379 408Q357 423 324 423Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 556,
    d: "M283 139H285L409 515H545L352 4Q337 -38 321 -78Q305 -119 282 -151Q260 -183 226 -202Q190 -222 138 -222Q90 -222 43 -208L52 -109Q75 -118 121 -118Q162 -117 185 -92Q208 -67 208 -26L11 515H159L283 139ZM443 737V609H327V737H443ZM121 609V737H237V609H121Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0131",
    horizAdvX: 278,
    d: "M72 0V515H206V0H72Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 944,
    d: "M490 588Q459 593 416 594Q310 593 252 527Q193 459 193 345Q193 241 251 174Q309 108 420 104Q463 104 490 110V588ZM890 588H630V416H868V306H630V110H894V0H629Q517 -2 405 -6Q340 -6 278 9Q214 23 162 60Q111 98 80 168Q47 236 47 345Q55 704 423 704Q526 701 629 698H890V588Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 944,
    d: "M176 257Q175 192 204 141Q233 87 305 86Q379 87 409 139Q418 151 424 165Q429 178 432 193Q438 223 438 255Q438 323 410 375Q379 427 305 429Q237 427 207 373Q176 319 176 257ZM572 216Q575 150 615 119Q654 86 715 86Q800 86 868 137L872 28Q866 25 854 18Q842 12 822 5Q782 -11 711 -12Q646 -12 591 6Q536 23 502 73Q461 21 407 4Q353 -13 305 -12Q177 -10 107 66Q36 141 36 254Q37 383 114 455Q189 526 305 527Q428 527 497 439Q528 484 576 506Q624 527 677 527Q815 525 863 433Q909 342 908 216H572ZM780 308Q779 358 756 393Q733 428 678 429Q627 428 600 393Q572 357 572 308H780Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0160",
    horizAdvX: 556,
    d: "M456 570Q389 599 314 600Q296 600 278 596Q259 592 242 581Q226 571 215 551Q204 532 204 503Q204 481 218 466Q232 451 253 439Q276 427 303 417Q329 406 358 394Q387 383 414 368Q442 352 463 329Q484 307 498 276Q510 244 510 199Q508 86 433 37Q358 -12 248 -12Q194 -12 157 -4Q119 3 69 15L82 141Q156 99 240 98Q283 98 323 120Q363 142 364 188Q364 213 352 231Q338 249 317 261Q271 285 212 307Q183 319 157 335Q130 350 107 371Q86 393 72 424Q58 455 58 497Q60 613 135 663Q207 710 302 710Q392 710 469 685L456 570H456ZM235 740L125 886H214L284 800L352 886H441L336 740H235Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0161",
    horizAdvX: 444,
    d: "M375 407Q346 418 319 424Q292 429 255 429Q227 429 203 418Q177 405 176 372Q177 343 213 331Q230 324 251 318Q272 312 293 304Q316 297 337 286Q357 274 373 258Q390 241 400 217Q409 192 409 156Q407 67 343 27Q279 -12 193 -12Q116 -11 41 10L49 120Q112 86 181 86Q209 86 238 100Q268 113 269 149Q269 169 260 182Q250 194 233 201Q198 215 153 227Q132 234 111 244Q90 254 73 270Q56 286 47 310Q36 333 36 367Q37 451 99 489Q157 527 238 527Q285 527 320 522Q354 516 384 508L375 407ZM174 585L64 731H153L223 645L291 731H380L275 585H174Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 667,
    d: "M266 276L11 698H175L340 405L508 698H656L406 276V0H266V276ZM501 880V764H385V880H501ZM179 764V880H295V764H179Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u017D",
    horizAdvX: 556,
    d: "M36 114L364 588H49V698H513V584L182 110H520V0H36V114ZM230 740L120 886H209L279 800L347 886H436L331 740H230Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u017E",
    horizAdvX: 500,
    d: "M47 515H455V405L199 104H464V0H36V109L297 411H47V515ZM202 585L92 731H181L251 645L319 731H408L303 585H202Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0192",
    horizAdvX: 556,
    d: "M238 406L269 546Q286 628 331 670Q375 710 463 710Q506 710 547 701L529 595Q517 598 504 603Q491 606 471 606Q439 606 424 584Q408 561 401 524L376 406H497L484 326H360L299 -3Q295 -29 286 -65Q276 -102 256 -137Q237 -172 202 -196Q167 -221 112 -222Q86 -222 60 -220Q33 -219 8 -212L28 -113Q53 -118 80 -118Q122 -116 136 -84Q149 -53 152 -27L222 326H109L124 406H238Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 278,
    d: "M192 731L297 585H208L140 671L70 585H-19L91 731H192Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C7",
    horizAdvX: 278,
    d: "M91 585L-19 731H70L140 645L208 731H297L192 585H91Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DA",
    horizAdvX: 278,
    d: "M33 685Q34 730 66 761Q96 791 140 792Q186 791 216 761Q245 730 246 685Q245 641 216 611Q186 579 140 579Q96 579 66 611Q34 641 33 685ZM87 685Q87 663 103 649Q117 633 140 633Q163 633 178 649Q192 663 192 685Q192 708 178 724Q163 738 140 738Q117 738 103 724Q87 708 87 685Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 278,
    d: "M-38 603Q-37 650 -8 687Q20 723 64 724Q87 724 106 718Q126 712 145 704Q164 696 182 690Q199 682 218 682Q262 684 262 731H316Q316 680 292 646Q266 611 219 610Q192 610 173 616Q152 621 133 628Q95 646 65 647Q40 646 28 633Q16 619 16 603H-38Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 500,
    d: "M0 315H500V223H0V315Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 1000,
    d: "M0 315H1000V223H0V315Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 278,
    d: "M125 698H244L181 448H34L125 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 278,
    d: "M98 698H244L152 448H34L98 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 278,
    d: "M98 140H244L152 -110H34L98 140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 481,
    d: "M125 698H244L181 448H34L125 698ZM328 698H447L384 448H237L328 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 481,
    d: "M98 698H244L152 448H34L98 698ZM301 698H447L355 448H237L301 698Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 481,
    d: "M301 140H447L355 -110H237L301 140ZM98 140H244L152 -110H34L98 140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2020",
    horizAdvX: 556,
    d: "M59 539H214V698H342V539H497V435H342V0H214V435H59V539Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2021",
    horizAdvX: 556,
    d: "M59 555H214V698H342V555H497V457H342V245H497V147H342V0H214V147H59V245H214V457H59V555Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 500,
    d: "M76 349Q77 423 128 473Q176 522 250 523Q324 522 374 473Q424 423 425 349Q424 276 374 226Q324 175 250 174Q176 175 128 226Q77 276 76 349Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 1000,
    d: "M97 0V140H237V0H97ZM430 0V140H570V0H430ZM763 0V140H903V0H763Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2030",
    horizAdvX: 1000,
    d: "M151 436Q170 436 180 446Q190 454 194 468Q201 498 200 537Q201 577 194 607Q190 622 180 630Q170 638 151 638Q133 638 123 630Q113 622 108 607Q100 577 101 537Q100 498 108 468Q113 454 123 446Q133 436 151 436ZM502 720H584L155 -22H73L502 720ZM151 364Q111 364 84 378Q56 392 39 416Q23 440 16 472Q9 504 9 540Q9 578 16 609Q20 624 26 638Q32 652 39 662Q56 685 84 698Q111 710 151 710Q193 710 220 698Q247 685 263 662Q292 615 292 540Q292 466 263 416Q247 392 220 378Q193 364 151 364ZM515 60Q534 60 544 70Q554 78 558 92Q565 122 564 161Q565 201 558 231Q554 246 544 254Q534 262 515 262Q497 262 487 254Q477 246 472 231Q464 201 465 161Q464 122 472 92Q477 78 487 70Q497 60 515 60ZM515 -12Q475 -12 448 2Q420 16 403 40Q387 64 380 96Q373 128 373 164Q373 202 380 233Q384 248 390 262Q396 276 403 286Q420 309 448 322Q475 334 515 334Q557 334 584 322Q611 309 627 286Q656 239 656 164Q656 90 627 40Q611 16 584 2Q557 -12 515 -12ZM851 -12Q811 -12 784 2Q756 16 739 40Q723 64 716 96Q709 128 709 164Q709 202 716 233Q720 248 726 262Q732 276 739 286Q756 309 784 322Q811 334 851 334Q893 334 920 322Q947 309 963 286Q992 239 992 164Q992 90 963 40Q947 16 920 2Q893 -12 851 -12ZM851 60Q870 60 880 70Q890 78 894 92Q901 122 900 161Q901 201 894 231Q890 246 880 254Q870 262 851 262Q833 262 823 254Q813 246 808 231Q800 201 801 161Q800 122 808 92Q813 78 823 70Q833 60 851 60Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 333,
    d: "M167 474H293L183 269L293 64H167L49 269L167 474Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 333,
    d: "M166 64H40L150 269L40 474H166L284 269L166 64Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    horizAdvX: 556,
    d: "M596 683L570 579Q522 603 452 603Q377 603 324 562T248 449H541L526 388H232Q228 349 232 310H508L494 249H248Q271 179 324 139T451 98Q520 98 570 120L576 8Q520 -12 432 -12Q303 -12 214 56Q122 125 95 249H-4L11 310H86Q83 350 86 388H-4L11 449H96Q124 568 215 639T430 710Q521 710 596 683Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 1000,
    d: "M465 698H610L709 438L807 698H952V282H854V576H852L746 282H671L565 576H563V282H465V698ZM165 618H48V698H386V618H269V282H165V618Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE300",
    horizAdvX: 278,
    d: "M221 740H138L1 886H138L221 740Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE301",
    horizAdvX: 278,
    d: "M139 886H276L139 740H56L139 886Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE302",
    horizAdvX: 278,
    d: "M191 886L296 740H207L139 826L69 740H-20L90 886H191Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE303",
    horizAdvX: 278,
    d: "M90 740L-20 886H69L139 800L207 886H296L191 740H90Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE304",
    horizAdvX: 278,
    d: "M-39 758Q-38 805 -9 842Q19 878 63 879Q86 879 105 873Q125 867 144 859Q163 851 181 845Q198 837 217 837Q261 839 261 886H315Q315 835 291 801Q265 766 218 765Q191 765 172 771Q151 776 132 783Q94 801 64 802Q39 801 27 788Q15 774 15 758H-39Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE305",
    horizAdvX: 278,
    d: "M299 880V764H183V880H299ZM-23 764V880H93V764H-23Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE308",
    horizAdvX: 278,
    d: "M140 879Q118 879 104 864T90 828Q90 806 104 792T140 778Q162 778 176 792T191 828Q191 850 177 864T140 879ZM245 828Q245 807 237 788T214 755T180 732T140 724Q119 724 100 732T67 755T45 788T36 828Q36 849 44 868T66 901T100 924T140 933Q161 933 180 925T214 902T236 869T245 828Z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "T",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "W",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Y",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xDD",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0178",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "T",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "W",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Y",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xDD",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xFD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xFF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0178",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "T",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "W",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xDD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0178",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ":",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ";",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "a",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "c",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "e",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "o",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "r",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "s",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "u",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "w",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "y",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE0",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE1",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE2",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE3",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE4",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE5",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE7",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE8",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE9",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEA",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEB",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF2",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF3",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF4",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF5",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF6",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF9",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFA",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFB",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFC",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFD",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xFF",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0161",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ":",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ";",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEC",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xED",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEF",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "-",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ":",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ";",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "a",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "r",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "u",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xC5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEA",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xEB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFA",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xFC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ",",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "-",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ";",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "A",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "a",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "e",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "i",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "o",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "u",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC0",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC1",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC2",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC3",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC4",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xC5",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE0",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE1",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE3",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE5",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE8",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE9",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEA",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEB",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEC",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xED",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xEF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF3",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF5",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF9",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFA",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFB",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xFC",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2019",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "-",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "c",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "d",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "n",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "q",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xE9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xEA",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xEB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF1",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xF6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "T",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "W",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "Y",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xDD",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0178",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "T",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "W",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "Y",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xDD",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0178",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "T",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "W",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "Y",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xDD",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0178",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "T",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "W",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "Y",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xDD",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0178",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "T",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "W",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "Y",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xDD",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0178",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "T",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "W",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "Y",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xDD",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xFD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xFF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0178",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2019",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ",",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "-",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ".",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ":",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ";",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "A",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "a",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "e",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "i",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "o",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "p",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "q",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "u",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "v",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC0",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC1",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC2",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC3",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC4",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xC5",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE0",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE1",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE3",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE5",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE8",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE9",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEA",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEB",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEC",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xED",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xEF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF3",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF5",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF6",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF9",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFA",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFB",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xFC",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ",",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ".",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ",",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "-",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ".",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ":",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ";",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "A",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "a",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "e",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "i",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "o",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "p",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "q",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "u",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "v",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC0",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC1",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC2",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC3",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC4",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xC5",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE0",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE1",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE3",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE5",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE8",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE9",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEA",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEB",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEC",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xED",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xEF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF2",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF3",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF5",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF6",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF9",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFA",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFB",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xFC",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u2018",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "s",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0161",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u2019",
    k: 69
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFrutiger65Bold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/frutiger-65bold.3151eef2941da24055b4760a7006e4f3.svg";